import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'

interface CalendarData {
  start_date: string
  end_date: string
  description: string
  name: string
  location: string
}

export const useCantileverAlerts = () => {
  const { ALERTS_URL } = useRuntimeVariables()
  const { authorizedAxios: axios } = useGeckoAuth()

  const sendEmail = async (
    email: string,
    subject: string,
    htmlContent: string,
    calendarData?: CalendarData
  ) => {
    await axios.post(`${ALERTS_URL}/api/v1/alerts/notify-crew`, {
      send_to: email,
      subject: subject,
      html_content: htmlContent,
      calendar_data: calendarData,
    })
  }

  const sendEmails = async (
    emailList: {
      email: string
      subject: string
      htmlContent: string
      calendarData?: CalendarData
    }[]
  ) => {
    const emailPromises = emailList.map((email) => {
      return sendEmail(
        email.email,
        email.subject,
        email.htmlContent,
        email.calendarData
      )
    })

    await Promise.all(emailPromises)
  }

  return {
    sendEmails,
  }
}
